export default "__VITE_ASSET__BZdE4ryj__"